import React, { Component } from 'react'
import { connect } from 'react-redux'

import Footer from './Footer'

class FooterContainer extends Component {
  render () {
    return (
      <Footer {...this.props} />
    )
  }
}

const mapStateToProps = state => {
  const { oidc: { user } } = state
  const { profile } = user || {}
  return { profile }
}

export default connect(mapStateToProps)(FooterContainer)



// WEBPACK FOOTER //
// ./src/App/Footer/FooterContainer.js